export default __webpack_public_path__ + "static/media/pvn-arte-8.7b4769df.webp";